"use strict";

Shopify.theme.jsUpsellPopup = {
  
  init: function init($section) {
    var _this = this;
    this.$section = $section
    this.isOpen = false
    // Add settings from schema to current object
    Shopify.theme.jsUpsellPopup = $.extend(this, Shopify.theme.getSectionData($section));
//  this.open()
    if(!isScreenSizeLarge()){
      this.slider = $section.find('.popup__content--products').flickity({
        wrapAroud:true,
        cellAlign:'left',
        watchCss:true,
        pageDots:false
      })
    } 
  },
  open: function open() {
    if (Cookies.get('upsell-popup') == 'opened' ) {
      return false;
    }
    var _this2 = this;
    if(_this2.isOpen)return;
    _this2.isOpen = true
    
    $.fancybox.open({
      src: '[data-popup-upsell]',
      type: 'inline',
      opts: {
        baseClass: 'popup-modal',
        hash: false,
        infobar: false,
        toolbar: false,
        smallBtn: false,
        touch: {
          vertical: false,
          momentum: false
        },
        beforeShow: function beforeShow() {
          // Remove previous slides (fix for theme editor)
          $('.popup-modal .fancybox-slide').empty();
        },
        afterShow: function afterShow() {
          if(_this2.slider){
            _this2.slider.flickity('resize')
          }
          // After content is loaded, attach event listener for custom close icon
          $(document).on('click', '[data-close]', function () {
            _this2.close();
          });
        },
        beforeClose: function beforeClose() {
          // Prevent duplicate triggers for close icon click
          _this2.$section.find('[data-close]').off();
        }
      }
    });
  },
  close: function close() {
    this.isOpen = false
    $.fancybox.close($('[data-popup-upsell]'));
    
    Cookies.set('upsell-popup','opened', {
      expires: parseInt(this.popup_days_to_hide)
    });
    
  },
  showThemeEditorState: function showThemeEditorState() {
    $('.popup-section-upsell').addClass('is-fixed-top'); // Prevent scroll to bottom

    this.open();
  },
  hideThemeEditorState: function hideThemeEditorState() {
    $('.popup-section-upsell').removeClass('is-fixed-top');
    this.close();
  },
  unload: function unload($section) {
    $.fancybox.destroy();
    $('.popup-modal .fancybox-slide').empty();
    $('[data-close]').off();
  }
};